export default __webpack_public_path__ + "static/desktop-9322c12c1986f784d3da1aa62542fa8c.png";